"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.results = void 0;
var React = require("react");
var react_redux_1 = require("react-redux");
var ResultAction_1 = require("@/pages/search/actions/sfilter/ResultAction");
var ResultItemComponent_1 = require("@/pages/search/components/ResultItemComponent");
var SfilterTypeGroup_1 = require("@/pages/common/states/sfilter/sections/SfilterTypeGroup");
var ResultPagination_1 = require("@/pages/search/components/ResultPagination");
var Heading_1 = require("@/pages/common/components/Heading");
var ResultMobilePromo_1 = require("@/pages/search/components/ResultMobilePromo");
var latLngContain_1 = require("@/utils/latLngContain");
var getIsViewportOutOfDistrict = function (state) {
    var _a;
    var neSwBound = ((_a = state.mapsearch.viewport) === null || _a === void 0 ? void 0 : _a.bound) || null;
    if (!neSwBound)
        return false;
    var selectedDistrictsLatLng = state.hfilter.districts.filter(function (it) { return it.selected; }).map(function (it) { return it.location; });
    if (!selectedDistrictsLatLng.length)
        return false;
    var insideDistrictsCount = selectedDistrictsLatLng.map(function (it) { return latLngContain_1.latLngContain(it, neSwBound.ne, neSwBound.sw); }).filter(function (it) { return it; }).length;
    return insideDistrictsCount === 0;
};
var mapStateToProps = function (state) { return (__assign(__assign({}, state.results), { filterType: SfilterTypeGroup_1.ListingPurposeType.toSfilterType(state.hfilter.listingType), symbol: state.layout.currencies.options.filter(function (it) { return it.key === state.layout.currencies.currentCurrencyId; })[0].symbol, googleApi: state.layout.googleApi, lang: state.layout.language.languages.filter(function (it) { return it.id === state.layout.language.current; })[0].code1, isViewportOutOfDistrict: getIsViewportOutOfDistrict(state) })); };
var mapDispatchToProps = function (dispatch) { return ({
    onChangePage: function (page) { return dispatch(ResultAction_1.default.onChangePage(page)); },
    onNewSearch: function () { return dispatch(ResultAction_1.default.onNewSearch()); },
    onEnquireClicked: function (item) {
        return dispatch(ResultAction_1.default.onEnquireClicked(item));
    },
    onFavClicked: function (item) { return dispatch(ResultAction_1.default.onFavClicked(item)); },
    onMouseUp: function (item) { return dispatch(ResultAction_1.default.onMouseUp(item)); },
    onMouseDown: function (item) { return dispatch(ResultAction_1.default.onMouseDown(item)); },
    onMouseEnter: function (item) { return dispatch(ResultAction_1.default.onMouseEnter(item)); },
    onMouseLeave: function (item) { return dispatch(ResultAction_1.default.onMouseLeave(item)); },
    onSaveSearchClicked: function () { return dispatch(ResultAction_1.default.onSaveSearchClicked()); },
    onLoadmore: function () { return dispatch(ResultAction_1.default.loadNextPage()); },
    onSaveSearchClose: function () { return dispatch(ResultAction_1.default.onSaveSearchClose()); },
    onDistrictClicked: function (districtName, districtId) {
        return dispatch(ResultAction_1.default.onDistrictClick(districtName, districtId));
    },
    onChangeSort: function (sortId) { return dispatch(ResultAction_1.default.onChangeSort(sortId)); },
    onCloseNoResultDialog: function () { return dispatch(ResultAction_1.default.onCloseNoResultDialog()); },
    onItemClicked: function (item) { return dispatch(ResultAction_1.default.onItemClicked(item)); },
    onClearDistrict: function () { return dispatch(ResultAction_1.default.onClearDistrict()); },
    onBackToDistrict: function () { return dispatch(ResultAction_1.default.onBackToDistrict()); },
}); };
exports.results = function (props) {
    var renderResultItems = function (resultItems, props) {
        if (resultItems.length === 0) {
            return;
        }
        return resultItems.map(function (it, index) {
            return (React.createElement(ResultItemComponent_1.default, { item: it, key: index, t: props.t, filterType: props.filterType, symbol: props.symbol, googleApi: props.googleApi, lang: props.lang, lazy: true, onEnquireClicked: props.onEnquireClicked, onFavClicked: props.onFavClicked, onMouseUp: props.onMouseUp, onMouseDown: props.onMouseDown, onMouseEnter: props.onMouseEnter, onMouseLeave: props.onMouseLeave, onDistrictClicked: props.onDistrictClicked, onItemClicked: props.onItemClicked }));
        });
    };
    var renderResultsItemSection = function (resultItems, isMobilePromoActive, props) {
        return (React.createElement("div", { className: "c-result__items" },
            isMobilePromoActive ? React.createElement(ResultMobilePromo_1.default, null) : null,
            renderResultItems(resultItems, props)));
    };
    var renderEmpty = function (props) {
        if (props.noResultDialogHide)
            return null;
        if (props.isViewportOutOfDistrict) {
            return (React.createElement("div", { className: "c-noresult" },
                React.createElement("div", { className: "c-noresult__icon" },
                    React.createElement("img", { src: "/res/img/404.jpg" })),
                React.createElement("div", { className: "c-noresult__body" },
                    React.createElement("div", { className: "c-noresult__title" }, props.t.emptyTitleViewportOutOfDistrict),
                    React.createElement("div", { className: "c-noresult__caption" }, props.t.emptyCaptionViewportOutOfDistrict)),
                React.createElement("div", { className: "c-noresult__actions" },
                    React.createElement("a", { onClick: props.onClearDistrict, className: "o-btn o-btn--primary o-btn--primary-flat c-noresult__action", style: { marginRight: 10 } }, props.t.clearDistrict),
                    React.createElement("a", { onClick: props.onBackToDistrict, className: "o-btn c-noresult__action" }, props.t.backToDistrict))));
        }
        return (React.createElement("div", { className: "c-noresult" },
            React.createElement("div", { className: "c-noresult__icon" },
                React.createElement("img", { src: "/res/img/404.jpg" })),
            React.createElement("div", { className: "c-noresult__body" },
                React.createElement("div", { className: "c-noresult__title" }, props.textImages && props.textImages.emptyTitle ? (React.createElement("img", { src: props.textImages.emptyTitle })) : props.t.emptyTitle),
                React.createElement("div", { className: "c-noresult__caption" }, props.textImages && props.textImages.emptyCaption ? (React.createElement("img", { src: props.textImages.emptyCaption })) : props.t.emptyCaption)),
            React.createElement("div", { className: "c-noresult__actions" },
                React.createElement("a", { target: "_blank", onClick: props.onNewSearch, className: "o-btn o-btn--primary o-btn--primary-flat c-noresult__action" }, props.textImages && props.textImages.emptyAction ? (React.createElement("img", { src: props.textImages.emptyAction })) : props.t.emptySearchNow))));
    };
    var renderLineBreak = function (props) {
        return (React.createElement("div", { id: "result-linebreak", className: "t--darker l-pad--3 l-pad-top--3" },
            React.createElement("h2", { className: "o-h1 l-pad--2 u-preserve-cap u-text-center" }, props.t.similarText)));
    };
    var renderResultResponse = function (props) {
        var renderSaveSearchPrompt = function (props, show) {
            return (React.createElement("div", { className: "c-rowcta" },
                React.createElement("div", { onClick: props.onSaveSearchClose, className: "c-rowcta__close" },
                    React.createElement("span", { className: "fal fa-times" })),
                React.createElement("div", { className: "c-rowcta__img" },
                    React.createElement("img", { src: "/res/img/recapture-1.jpg", alt: "" })),
                React.createElement("div", { className: "c-rowcta__body" },
                    React.createElement("div", { className: "c-rowcta__info" },
                        React.createElement("div", { className: "c-rowcta__title" }, props.t.stillThinking),
                        React.createElement("div", { className: "c-rowcta__caption" }, props.t.saveThisSearchCaption)),
                    React.createElement("div", { className: "c-rowcta__action" },
                        React.createElement("button", { id: "recapture-button-pagination", onClick: props.onSaveSearchClicked, className: "o-btn o-btn--primary" },
                            React.createElement("span", { className: "fal fa-bell" }),
                            "\u00A0",
                            props.t.saveThisSearch)))));
        };
        var renderViewFirstPage = function (props) {
            var gotoPageOne = function () {
                props.onChangePage(1);
            };
            return (React.createElement("div", { className: "c-result__firstpage" },
                React.createElement("a", { onClick: gotoPageOne, className: "o-textbtn" }, props.t.backToPageOne)));
        };
        var renderPaginationSection = function (hasResult, resultResponse, props) {
            if (hasResult) {
                return ResultPagination_1.renderPagination(resultResponse.page, resultResponse.pageTotal, props.onChangePage, props.t, props.currentUrl);
            }
            return '';
        };
        var renderResults = function (resultResponse, props, index) {
            if (!resultResponse || !resultResponse.results)
                return renderEmpty(props);
            var hasResult = resultResponse.results && resultResponse.results.length > 0 && resultResponse.pageTotal > 0;
            var resultItems = resultResponse.results.filter(function (it) { return !it.isRelated; });
            var relatedItems = resultResponse.results.filter(function (it) { return it.isRelated; });
            var topIsNotFirst = (props.resultResponses.length && props.resultResponses.length &&
                props.resultResponses[0].page === resultResponse.page &&
                resultResponse.page > 1)
                ? true
                : false;
            var showPrompt = resultResponse.showSaveSearchPrompt;
            return (React.createElement("div", { key: index, className: "c-result", "custom-sliderinit": resultResponse.sliderInit ? '1' : '0' },
                topIsNotFirst ? renderViewFirstPage(props) : '',
                showPrompt ? renderSaveSearchPrompt(props, showPrompt) : '',
                hasResult
                    ? renderResultsItemSection(resultItems, true, props)
                    : renderEmpty(props),
                React.createElement("div", { className: "u-mobile-hidden" }, renderPaginationSection(hasResult, resultResponse, props)),
                relatedItems.length ? renderLineBreak(props) : '',
                relatedItems.length
                    ? renderResultsItemSection(relatedItems, false, props)
                    : ''));
        };
        return props.resultResponses && props.resultResponses.length ? props.resultResponses.map(function (resultResponse, index) {
            return renderResults(resultResponse, props, index);
        }) : renderEmpty(props);
    };
    var renderMoreButton = function (props) {
        if (props.resultResponses.length) {
            var page = props.resultResponses[props.resultResponses.length - 1];
            if (page.page !== page.pageTotal) {
                return (React.createElement("div", { className: "c-result__loadmore" },
                    React.createElement("a", { onClick: props.onLoadmore, className: "o-textbtn" }, props.t.loadmore)));
            }
        }
    };
    var renderResultHeader = function (props) {
        var pageCount = props.resultResponses.length;
        var resultPagerText = pageCount ? props.t.showing + " " + props.resultResponses[pageCount - 1].page + " / " + props.resultResponses[pageCount - 1].pageTotal : '';
        return (React.createElement(React.Fragment, null,
            React.createElement(Heading_1.default, null),
            React.createElement("div", { className: "c-result__head-meta" },
                React.createElement("div", { className: "c-result__head-meta-page" }, resultPagerText))));
    };
    var hasResult = props.resultResponses.length && props.resultResponses[props.resultResponses.length - 1].pageTotal > 0 && props.resultResponses[props.resultResponses.length - 1].results.length;
    return (React.createElement("div", { className: "c-result__results" },
        hasResult ? renderResultHeader(props) : null,
        React.createElement("div", { className: "c-result__result-page" }, renderResultResponse(props)),
        renderMoreButton(props),
        React.createElement("div", { className: "c-result__loading" },
            React.createElement("div", { className: "c-result__loading-wrap" },
                React.createElement("span", { className: "c-result__loading-icon fal fa-sync" }),
                React.createElement("div", { className: "c-result__loading-text" }, props.t.loading)))));
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(exports.results);
